<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">ติดตามความก้าวหน้า Fundamental</div>
        <div class="d-flex align-center font-type-bold txt-head black--text">
          <Iconify
            icon="ion:mail-unread"
            color="var(--theme-color-one)"
            class="mr-3"
          ></Iconify>
          โครงการที่ได้รับการอนุมัติ
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
              placeholder="สถานะ"
              hide-details
              :items="statusMaster"
              @onChange="
                searchData.status = $event;
                getFundamentalList();
              "
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-inner-icon="search"
              @onChange="searchData.keyword = $event"
              @onEnter="getFundamentalList()"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end">
          <Button @onClick="createProject"> กรอกแบบฟอร์ม </Button>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
          v-for="(item, i) in tableHeader"
          :key="i"
          :style="{ width: item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <ProgressFundamentalItem
          v-for="(item, i) in fundamentalList"
          :key="i"
          :item="item"
          :index="i"
          :headers="tableHeader"
        ></ProgressFundamentalItem>
      </div>

      <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getFundamentalList"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import Button from "../../components/input/Button";
import SelectBox from "../../components/input/SelectBox";
import MainProjectOfferItem from "../../components/MainProjectOfferItem";
import ProgressFundamentalItem from "../../components/ProgressFundamentalItem";

export default {
  name: "ProgressFundamentalList",
  components: {
    TextField,
    SelectBox,
    MainProjectOfferItem,
    ProgressFundamentalItem,
    Button,
  },
  data() {
    return {
      tableHeader: [
        {
          name: "",
          width: "8%",
        },
        {
          name: "ลำดับ",
          width: "6%",
        },
        {
          name: "รหัสโครงการ",
          width: "13%",
        },
        {
          name: "ชื่อโครงการ",
          width: "34%",
        },
        {
          name: "แผนงานที่ยื่น",
          width: "17%",
        },
        {
          name: "สถานะรวม",
          width: "17%",
        },
        {
          name: "",
          width: "5%",
        },
      ],
      fundamentalList: [],
      formFundamentalList: [],
      searchData: {
        status: null,
        keyword: null,
      },
      statusMaster: [
        "Draft",
        "Submitted",
      ],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    this.getFundamentalList();
  },
  methods: {
    createProject() {
      this.$router.push({ name: "ProgressFundamentalForm" });
    },
    async getFundamentalList(page) {
      let payload = {
        page: page,
        per_page: 10,
        status: this.searchData.status ?? this.statusMaster.join(","),
        keyword: this.searchData.keyword,
      };

      let res;
      res = await this.$apiFire("Fundamental/getFundamentalList", payload);
      console.log(res);
      console.log(res.data);
      this.fundamentalList = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1,
        };
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };

    },
  },
};
</script>

<style scoped>
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
